/**
 * The branch-admin management features — the same set the old manage grid
 * showed. Each is its own top-level route (mirroring the bos-app one-item-one-
 * route convention), rendered as a "coming soon" stub until built. This single
 * list drives the sidebar nav (`layout/navigation.ts`), the routes
 * (`router/AppRouter.tsx`), and the dashboard tiles (`pages/dashboard`), so the
 * three never drift.
 *
 * `slug` doubles as the `seller.actions.<slug>` (pages) label key for the
 * dashboard tiles and the `layout.navigation.manage.<slug>` (components) label
 * key for the sidebar; `icon` mirrors the POS action icons.
 */
export type ManageFeature = {
    slug: string;
    icon: string;
    path: string;
};

export const MANAGE_FEATURES: ManageFeature[] = [
    { slug: 'receive', icon: 'solar:inbox-in-bold-duotone', path: '/receive' },
    {
        slug: 'stocktake',
        icon: 'solar:clipboard-list-bold-duotone',
        path: '/stocktake',
    },
    { slug: 'cash', icon: 'solar:safe-square-bold-duotone', path: '/cash' },
    {
        slug: 'debtors',
        icon: 'solar:hand-money-bold-duotone',
        path: '/debtors',
    },
    {
        slug: 'zReport',
        icon: 'solar:document-text-bold-duotone',
        path: '/z-report',
    },
    { slug: 'reports', icon: 'solar:chart-2-bold-duotone', path: '/reports' },
    {
        slug: 'promotions',
        icon: 'solar:tag-bold-duotone',
        path: '/promotions',
    },
    { slug: 'alerts', icon: 'solar:bell-bold-duotone', path: '/alerts' },
];
